// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.cloud-variable-badge_badge_ddMpe {
    padding: 0.5rem;
    margin: 5px 0 8px 0;
    border: 1px solid var(--badge-border);
    background-color: var(--badge-background);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border-radius: 0.5rem;
}

.cloud-variable-badge_title_aiYWM {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: bold;
}

.cloud-variable-badge_cloud-icon_wYm0i {
    filter: var(--filter-icon-gray);
}

.cloud-variable-badge_servers___7n2 {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.cloud-variable-badge_server_RaPJG {
    border: 1px solid var(--ui-black-transparent);
    padding: 0.25rem 0.5rem;
    margin: 0;
    background: none;
    border-radius: 1rem;
}

.cloud-variable-badge_server_RaPJG.cloud-variable-badge_selected_ubk0_ {
    background-color: var(--looks-secondary);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-cloud-variable-badge/cloud-variable-badge.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,eAAe;IACf,mBAAmB;IACnB,qCAAqC;IACrC,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.badge {\n    padding: 0.5rem;\n    margin: 5px 0 8px 0;\n    border: 1px solid var(--badge-border);\n    background-color: var(--badge-background);\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    border-radius: 0.5rem;\n}\n\n.title {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-weight: bold;\n}\n\n.cloud-icon {\n    filter: var(--filter-icon-gray);\n}\n\n.servers {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.server {\n    border: 1px solid var(--ui-black-transparent);\n    padding: 0.25rem 0.5rem;\n    margin: 0;\n    background: none;\n    border-radius: 1rem;\n}\n\n.server.selected {\n    background-color: var(--looks-secondary);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export var badge = `cloud-variable-badge_badge_ddMpe`;
export var title = `cloud-variable-badge_title_aiYWM`;
var _1 = `cloud-variable-badge_cloud-icon_wYm0i`;
export { _1 as "cloud-icon" };
export var cloudIcon = `cloud-variable-badge_cloud-icon_wYm0i`;
export var servers = `cloud-variable-badge_servers___7n2`;
export var server = `cloud-variable-badge_server_RaPJG`;
export var selected = `cloud-variable-badge_selected_ubk0_`;
export default ___CSS_LOADER_EXPORT___;
